

































































































import Vue from 'vue'
import Footer from '@/components/Footer.vue';
import Header from '@/components/Header.vue'; // @ is an alias to /src
import SearchResultModal from "@/components/SearchResultModal.vue";
import io from 'socket.io-client';
import axios from 'axios';
import LanguageSelector from "@/components/LanguageSelector.vue";
import { EventBus } from "@/event-bus";


export default {
  props: {
    source: String
  },
  components: {
    Header,
    Footer,
    SearchResultModal,
    LanguageSelector
  },
  data() {
    return {
      drawer: false,
      socket: null,
      search: null
    }
  },
  mounted() {
    const locale = localStorage.getItem("lang");
    if (locale) {
      this.setLocale(locale);
    }

    if (Vue.config.productionTip) {
      console.log(`  #####       #####  
  #     #     #     # 
  #     #           # 
  #####       #####  
  #     # ### #       
  #     # ### #       
  #####  ### ####### Inspect - 2024`)
    }

    const ref = this

    window.addEventListener('keyup', function (event) {
      if (event.keyCode == 16) {
        ref.$store.state.key_shift = false
      }
    });

    window.addEventListener('keydown', function (event) {
      if (event.keyCode == 16) {
        ref.$store.state.key_shift = true
      }
    });

  },
 
  methods: {
    globalSearch: function () {
      this.$store.state.search_drawer = !this.$store.state.search_drawer
    },
    logout: function () {
      this.$router.push({ name: 'logout' })
    },
    inspectCompact: function () {
      this.$router.push({ name: 'inspect_compact' })
    },
    goOverview: function () {
      this.$router.push({ name: 'overview' })
    },
    goChecklist: function () {
      this.$router.push({ name: 'checklists' })
    },
    goMachineList: function () {
      this.$router.push({ name: 'machines-list' })
    },
    goMessageFormats: function () {
      this.$router.push({ name: 'message-formats' })
    },
    goMachineGroups: function () {
      this.$router.push({ name: 'machines' })
    },
    goMachineGroupsCompany: function () {
      this.$router.push({ name: 'machines-company' })
    },
    goInspections: function () {
      this.$router.push({ name: 'inspections' })
    },
    goUpdates: function () {
      this.$router.push({ name: 'updates' })
    },
    goProject: function () {
      this.$router.push({ name: 'project' })
    },
    goFinalize: function () {
      this.$router.push({ name: 'cancelfinalization' })
    },
    goBilling: function () {
      this.$router.push({ name: 'billing' })
    },
    goUser: function () {
      this.$router.push({ name: 'users' })
    },
    dialogClosed: function (val) {
      this.showSearchResult = false
    },
    setLocale(locale) {
      console.log('setLocale', locale);
      
      if (locale) {
        this.$i18n.locale = locale;
        this.$store.state.lang = locale;
        axios.defaults.headers.common['x-lang'] = locale;
      }
    },
    onLanguageChanged(language) {
      console.log('onLanguageChanged', language);
      // 
      localStorage.setItem("lang", language.locale);
      this.setLocale(language.locale);
    },
  },
  computed: {
    searchField: function () {
      return this.$store.state.searchField;
    },
    headerT: function () {
      return this.$store.state.headerTitle;
    },
    userRole: function () {
      if (this.$store.getters.userRole) {
        return this.$store.getters.userRole
      }
      return {}
    }
  },
  created() {
    console.log("--- ", this.$store.getters.companyId)
  }

}
